// extracted by mini-css-extract-plugin
export default {"have":"Account_have__NQkAT","login":"Account_login__kDg0Y","or":"Account_or__nnrub","signup":"Account_signup__BTO4-"};